module.exports = __webpack_public_path__ + "img/calendar.5cac185f.svg";